module.exports = __webpack_public_path__ + "static/media/map-marker-smile.1ca14266.svg";